import { createAsyncThunk } from "@reduxjs/toolkit";
import { Axios } from "api/axios";
import { InventoryAxios } from "api/InventoryAxios";

// export interface District {
//   id?: string;
//   packageName: string;
//   districtCode: string;
//   districtName: string;
//   state: string;
//   status: boolean;
//   createBy?: string;
//   updatedBy?: string;
//   createDate?: string;
//   updateDate?: string;
// }
export interface PaginatedResponse<T> {
  count: number;
  total_pages: number;
  next: string | null;
  previous: string | null;
  results: T[];
}

export const fetchInventoryStockTransferPendingApproval = createAsyncThunk(
  "inventory/fetchInventoryItemRequestPendingApproval",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
  }) => {
    try {
      const params = new URLSearchParams();
      params.append("page", page.toString());
      params.append("page_size", pageSize.toString());
      if (search) params.append("search", search);
      if (sort) {
        const orderingValue = order === "desc" ? `-${sort}` : sort;
        params.append("ordering", orderingValue);
      }

      if (filters && filters.length > 0) {
        console.log(JSON.stringify(filters));
        filters.forEach(
          ({
            filterField,
            filterValue,
          }: {
            filterField: string;
            filterValue: any;
          }) => {
            if (
              filterField &&
              filterValue !== undefined &&
              filterValue !== null
            ) {
              if (typeof filterValue === "object" && filterValue !== null) {
                // Handle cases like { from_date: ..., to_date: ... }
                Object.entries(filterValue).forEach(([key, value]) => {
                  if (value !== undefined && value !== null && value !== "") {
                    params.append(key, String(value));
                  }
                });
              } else {
                params.append(filterField, filterValue);
              }
            }
          }
        );
      }

      const response: any = await InventoryAxios.get(`/api/stock-transfer-request/pending-approval-list/?status=Pending&${params.toString()}`);
      console.log('response data ', response?.data?.data)

      // const pendingOnly = (response?.data?.data || []).filter(
      //   (item: any) => item.status?.toLowerCase() === "pending"
      // );


      return {
        data: response?.data?.data || [],
        // data: pendingOnly,
        rowCount: response?.data?.count || 0,
      };
    } catch (error: any) {
      console.error(
        "fetch Item Request  List error:",
        error.response?.data || error.message
      );
      throw new Error("Network Error");
    }
  }
);


export const approveStockTransfer = createAsyncThunk(
  "inventory/approveStockTransfer",
  async ({
    id,
    data,
  }: {
    id: string;
    data: any;
  }) => {

    const response = await InventoryAxios.post(`/api/stock-transfer-request/approve/${id}/`, data);
    return response.data;
  }
);


export const rejectStockTransfer = createAsyncThunk(
  "inventory/rejectStockTransfer",
  async ({
    id,
    data,
  }: {
    id: string;
    data: any;
  }) => {

    const response = await InventoryAxios.post(`/api/stock-transfer-request/reject/${id}/`, data);
    return response.data;
  }
);

